import React, { useEffect, useState, useMemo } from "react";
import { GlobalStyle } from "../../common/styles/global.js";
import { Navbar } from "../../common/components/Navbar.js";
import {
  HomeContent,
  Typewriter,
  Output,
  CursorH1,
  HomeText,
  MainboxText,
} from "../../common/styles/components.js";

export const Home = () => {
  const words = useMemo(() => [
    "Software Engineer",
    "Coffee-Fueled",
    "Love my cats",
  ], []);
  const [currentWord, setCurrentWord] = useState("");
  const [wordIndex, setWordIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  useEffect(() => {
    const typingInterval = setInterval(() => {
      if (charIndex < words[wordIndex].length) {
        setCurrentWord((prev) => prev + words[wordIndex][charIndex]);
        setCharIndex((prev) => prev + 1);
      } else {
        clearInterval(typingInterval);
        const timeout = setTimeout(() => {
          setCharIndex(0);
          setCurrentWord("");
          setWordIndex((prev) => (prev + 1) % words.length);
        }, 1000);
        return () => clearTimeout(timeout);
      }
    }, 150);

    return () => clearInterval(typingInterval);
  }, [charIndex, wordIndex, words]);

  return (
    <>
      <GlobalStyle />
      <div className="main">
        <div id="mainbox">
          <Navbar />
          <HomeContent>
            <Typewriter>
              <Output>
                <CursorH1>
                  {currentWord}
                </CursorH1>
              </Output>
              <HomeText>
                <MainboxText>Hello world!</MainboxText>
                <MainboxText>
                  I'm Marcellus, a passionate software engineer with a strong focus on building impactful, scalable solutions.
                  With experience in systems programming, backend development, and a deep love for problem-solving,
                  I balance technical excellence with a user-first mindset.
                  <br></br>
                  <br></br>
                  <a href="https://calendar.app.google/2ypr95fsLUbgaJTD7" target="_blank" rel="noopener noreferrer">Let's build something great together!</a>
                </MainboxText>
              </HomeText>
            </Typewriter>
          </HomeContent>
        </div>
      </div>
    </>
  );
};
